import { defineNuxtPlugin } from '#app'
import { nextTick } from 'vue'
import { useLanguageDetection } from '@/composables/useLanguageDetection'

export default defineNuxtPlugin(async () => {
  await nextTick()
  await useLanguageDetection().autoSwitchLanguage()
})
